import axios, { isAxiosError } from 'axios';
import qs from 'qs';

import { rethrowDecodedBlobError } from '@/feature/utils/fileDownload';

axios.defaults.baseURL = '/api';

axios.defaults.paramsSerializer = {
  serialize: function paramsSerializer(params: Record<string, unknown>) {
    return qs.stringify(params, { arrayFormat: 'repeat', allowDots: true, skipNulls: true });
  },
};

const CHANGE_PASSWORD_PATH = '/change-password';

// A temporary password re-issued mid-session only surfaces as this 403, since /auth/current is cached.
axios.interceptors.response.use(undefined, async (error: unknown) => {
  if (!isAxiosError(error) || error.response?.status !== 403) {
    throw error;
  }

  try {
    await rethrowDecodedBlobError(error);
  } catch {
    // The decoder always rethrows; only its rewrite of a Blob body matters here.
  }

  const data = error.response.data;
  if (
    (data?.type ?? data?.message) === 'PASSWORD_CHANGE_REQUIRED' &&
    window.location.pathname !== CHANGE_PASSWORD_PATH
  ) {
    const back = window.location.pathname + window.location.search;
    window.location.assign(`${CHANGE_PASSWORD_PATH}?redirect=${encodeURIComponent(back)}`);
  }
  throw error;
});
